<template>
	<div>
		<Button type="button" icon="pi pi-filter-slash" label="Clear" class="p-button inverted" @click="clearFilter1()" />
		<span class="p-input-icon-left">
			<i class="pi pi-search" />
			<InputText v-model="filters1['global'].value" placeholder="Keyword Search" />
		</span>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
export default defineComponent({
	name: "TableHeader",
	components: {},
	props: {
		label: {
			type: String,
			Array,
			required: true,
		},
		i18nName: {
			type: String,
			default: "",
		},
		helpElementName: {
			type: String,
			default: "",
			required: false,
		},
		required: {
			type: Boolean,
			default: false,
		},
	},
})
</script>

<style scoped></style>
